<template>
  <v-container fluid>
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <h5 class="grey--text">Vista general</h5>
    <v-row>
        <v-col md="6">
            <h2 class="deep-purple--text lighten-3">
              {{$t('campus_group_admins.all_campus_group_admins')}}
            </h2>
        </v-col>
        <v-col md="6">
            <v-row justify="end" class="my-0 mr-4">
                <v-btn
                  text
                  small
                  color="deep-purple lighten-1"
                  @click.prevent="toggleCreateCampusGroupAdminModal()"
                >
                    <v-icon size="21" class="mr-1">
                    mdi-plus
                    </v-icon>
                    {{ $t('campus_group_admins.create') }}
                </v-btn>
            </v-row>
        </v-col>
    </v-row>
    <campus-group-admins-filter
      v-model="params"
      @search="search(true)"
    ></campus-group-admins-filter>
    <campus-group-admins-data-table
      :table-loading="loading"
      v-model="page"
      :items="campusGroupAdmins"
      :length="totalPages"
      @edit="editCampusGroupAdmin"
      @refresh="handleRefresh"
    ></campus-group-admins-data-table>
    <create-campus-group-admin-modal
      v-model="isCreateCampusGroupAdminModalOpen"
      @onCancel="toggleCreateCampusGroupAdminModal"
      @onSave="handleCampusGroupAdminCreated"
    />
  </v-container>
</template>

<script>
import CreateCampusGroupAdminModal from '@/components/campusGroupAdmins/modals/CreateCampusGroupAdminModal.vue';
import CampusGroupAdminsFilter from '../../components/core/filters/CampusGroupAdminsFilter.vue';
import CampusGroupAdminsDataTable from '../../components/campusGroupAdmins/CampusGroupAdminsDataTable.vue';
import LoadingMixin from '../../mixins/loading';
import snackbarMixin from '../../mixins/snackbar';

import campusGroupAdminService from '../../services/campusGroupAdmin.service';
import { defaultCampusGroupAdminFilter } from '../../constants/filters';

export default {
  name: 'CampusGroupAdmins',
  components: {
    CampusGroupAdminsFilter,
    CampusGroupAdminsDataTable,
    CreateCampusGroupAdminModal,
  },
  data: () => ({
    page: 1,
    params: { ...defaultCampusGroupAdminFilter },
    isCreateCampusGroupAdminModalOpen: false,
  }),
  mixins: [LoadingMixin, snackbarMixin],
  computed: {
    campusGroupAdmins() {
      return this.$store.state.campusGroupAdmins;
    },
    totalPages() {
      return this.$store.state.campusGroupAdminsTotalPages;
    },
  },
  mounted() {
    this.search(true);
  },
  methods: {
    toggleCreateCampusGroupAdminModal() {
      this.isCreateCampusGroupAdminModalOpen = !this.isCreateCampusGroupAdminModalOpen;
    },
    editCampusGroupAdmin(campusGroupAdmin) {
      this.$router.push(`/edit/campus-group-admins/${campusGroupAdmin.id}`);
    },
    handleRefresh() {
      this.search(true);
    },
    handleCampusGroupAdminCreated() {
      this.toggleCreateCampusGroupAdminModal();
      this.search(true);
      this.snackbarSuccess('Administrador de grupo de sede creado exitosamente');
    },
    async search(showLoading = false) {
      if (showLoading) {
        this.loader();
      }

      const queryParams = {
        page: this.page,
        ...this.params,
      };

      try {
        const response = await campusGroupAdminService.getCampusGroupAdmins(queryParams);
        this.$store.commit('SET_CAMPUS_GROUP_ADMINS', response.data.data);
        this.$store.commit('SET_CAMPUS_GROUP_ADMINS_TOTAL_PAGES', response.data.total_page);
      } catch (error) {
        this.snackbarError('Error al cargar administradores de grupo de sede');
      } finally {
        if (showLoading) {
          this.loader();
        }
      }
    },
  },
  watch: {
    page() {
      this.search();
    },
  },
};
</script>
